import { Button } from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

import type { DashboardSelectedDevice } from '../dashboard.types';

import { DashboardCardTitle } from './dashboard-card-title';
import { DashboardWidget } from './dashboard-widget';
import { DeviceOverviewItem } from './device-overview-item';
import { SectionFeedback } from './section-feedback';

import './device-overview-card.scss';

interface DeviceOverviewCardProps {
  selectedDevices: DashboardSelectedDevice[];
  onConfigure: () => void;
}

export function DeviceOverviewCard({
  selectedDevices,
  onConfigure,
}: DeviceOverviewCardProps) {
  const { t } = useTranslation();

  return (
    <DashboardWidget className="device-overview-card">
      <div className="dashboard-widget__header">
        <DashboardCardTitle
          icon="star"
          title={t('dashboard.deviceOverview.title')}
          hint={t('dashboard.deviceOverview.hint')}
          subheadline={t('dashboard.deviceOverview.lastHour')}
        />
        <SectionFeedback sectionId="device-overview" />
      </div>

      {selectedDevices.length === 0 ? (
        <div className="device-overview-card__empty">
          <strong>{t('dashboard.deviceOverview.emptyTitle')}</strong>
          <span>{t('dashboard.deviceOverview.emptyDescription')}</span>
          <Button type="button" variant="secondary" onClick={onConfigure}>
            {t('dashboard.deviceOverview.configure')}
          </Button>
        </div>
      ) : (
        <div className="device-overview-card__devices">
          {selectedDevices.map((selectedDevice) => (
            <DeviceOverviewItem
              key={`${selectedDevice.manufacturer}-${selectedDevice.serialNumber}`}
              selectedDevice={selectedDevice}
              onConfigure={onConfigure}
            />
          ))}
        </div>
      )}
    </DashboardWidget>
  );
}
